import React from "react";
import { Animated, Platform, TouchableWithoutFeedback } from "react-native";

/**
 * Hamburger menu button with a spin animation, based on: https://github.com/GeekyAnts/react-native-hamburger
 */
export default class MenuButton extends React.Component {
  constructor(props) {
    super(props);

    this.handlePress = this.handlePress.bind(this);
  }

  spinCross() {
    if (this.props.active) {
      Animated.spring(this.containerAnim, {
        toValue: 1,
        useNativeDriver: Platform.OS !== "web"
      }).start();
      Animated.spring(this.topBar, {
        toValue: 0.9,
        useNativeDriver: Platform.OS !== "web"
      }).start();
      Animated.spring(this.bottomBar, {
        toValue: 0.9
      }).start();
      Animated.spring(this.bottomBarMargin, {
        toValue: -10
      }).start();
      Animated.spring(this.middleBarOpacity, {
        toValue: 0,
        duration: 30,
        useNativeDriver: Platform.OS !== "web"
      }).start();
    } else {
      Animated.spring(this.containerAnim, {
        toValue: 0,
        useNativeDriver: Platform.OS !== "web"
      }).start();
      Animated.spring(this.topBar, {
        toValue: 0,
        useNativeDriver: Platform.OS !== "web"
      }).start();
      Animated.spring(this.bottomBar, {
        toValue: 0
      }).start();
      Animated.spring(this.bottomBarMargin, {
        toValue: 4
      }).start();
      Animated.timing(this.middleBarOpacity, {
        toValue: 1,
        duration: 600,
        useNativeDriver: Platform.OS !== "web"
      }).start();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active) {
      this.spinCross();
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.menuAnimating !== true;
  }

  handlePress() {
    if (this.props.menuAnimating !== true) {
      this.props.onPress();
    }
  }

  render() {
    const {
      props: { active, color }
    } = this;

    if (active) {
      this.containerAnim = this.containerAnim || new Animated.Value(1);
      this.topBar = this.topBar || new Animated.Value(0.9);
      this.bottomBar = this.bottomBar || new Animated.Value(0.9);
      this.bottomBarMargin = this.bottomBarMargin || new Animated.Value(-10);
      this.middleBarOpacity = this.middleBarOpacity || new Animated.Value(0);
    }

    this.containerAnim = this.containerAnim || new Animated.Value(0);
    this.topBar = this.topBar || new Animated.Value(0);
    this.bottomBar = this.bottomBar || new Animated.Value(0);
    this.middleBarOpacity = this.middleBarOpacity || new Animated.Value(1);
    this.bottomBarMargin = this.bottomBarMargin || new Animated.Value(4);
    this.topBarMargin = this.topBarMargin || new Animated.Value(0);
    this.marginLeft = this.marginLeft || new Animated.Value(0);

    return (
      <TouchableWithoutFeedback onPress={this.handlePress}>
        <Animated.View
          style={{
            zIndex: 100,
            width: 30,
            justifyContent: "center",
            alignItems: "center",
            height: 35,
            transform: [
              {
                rotate: this.containerAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: ["0deg", "360deg"]
                })
              }
            ]
          }}
        >
          <Animated.View
            style={{
              height: 3,
              width: 19,
              backgroundColor: color ? color : "black",
              transform: [
                {
                  rotate: this.topBar.interpolate({
                    inputRange: [0, 1],
                    outputRange: ["0deg", "-50deg"]
                  })
                }
              ]
            }}
          />

          <Animated.View
            style={{
              height: 3,
              width: 19,
              opacity: this.middleBarOpacity,
              backgroundColor: color ? color : "black",
              marginTop: 4
            }}
          />

          <Animated.View
            style={{
              height: 3,
              width: 19,
              backgroundColor: color ? color : "black",
              marginTop: this.bottomBarMargin,
              transform: [
                {
                  rotate: this.bottomBar.interpolate({
                    inputRange: [0, 1],
                    outputRange: ["0deg", "50deg"]
                  })
                }
              ]
            }}
          />
        </Animated.View>
      </TouchableWithoutFeedback>
    );
  }
}
